import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import MainLayout from './MainLayout';
import { ParallaxProvider } from 'react-scroll-parallax';

const Layout = ({ children }) => (
	<StaticQuery
		query={graphql`
			query SiteTitleQuery {
				site {
					siteMetadata {
						title
					}
				}
			}
		`}
		render={(data) => (
			<React.Fragment>
				<Helmet>
					<html lang='en' />
				</Helmet>
				<Wrapper>
					<ParallaxProvider>
						<MainLayout>{children}</MainLayout>
					</ParallaxProvider>
				</Wrapper>
			</React.Fragment>
		)}
	/>
);

class Wrapper extends React.Component {
	state = { ready: false };

	componentDidMount = () => {
		if (typeof window !== 'undefined') {
			const uikit = require('uikit');
			this.setState({ ready: true });
		}
	};

	render() {
		return <div>{this.state.ready && this.props.children}</div>;
	}
}

Layout.propTypes = {
	children: PropTypes.node.isRequired
};

export default Layout;
